module.exports = __webpack_public_path__ + "img/botijoes.169a10f7.png";